module.exports = __webpack_public_path__ + "static/img/img_culture_b.636b4d44.png";